import { useState, useMemo } from 'react'
import { Text } from 'react-native'
import styled from 'styled-components'
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import DatePicker from 'react-datepicker'
import { format } from 'date-fns'
import dayjs from 'dayjs'
import CustomDropdown from '../../../../Components/DropDown/CustomDropdown'
import Icons from '../../../../Constants/Icons'
import { useFormContext } from '../FormProvider'
import styles from '../../../Style'

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
`

const Checkbox = styled.div`
  cursor: pointer;
`

const EventVisibility = () => {
  const { formData, setFormData, errors } = useFormContext()
  const [openTimePicker, setOpenTimePicker] = useState(false)

  // Memoized dropdown label
  const dropdownLabel = useMemo(
    () =>
      formData.VisibilityType ? (
        formData.VisibilityType
      ) : (
        <div style={{ color: 'rgb(129, 129, 129)' }}>
          Select Event Visibility Type
        </div>
      ),
    [formData.VisibilityType]
  )


  return (
    <div>
      <Text style={styles.labelPhoto}>Event Visibility</Text>

      <div style={{ margin: '20px 0' }}>
        <div
          className={`Category_name Subcategory_drop ${
            errors.VisibilityType ? 'invalid' : 'valid'
          }`}
          style={styles.CustomDrop}
        >
          <CustomDropdown
            dropDownLabel={dropdownLabel}
            items={['Public', 'Private']}
            color='blue'
            onSelect={item =>
              setFormData(prev => ({ ...prev, VisibilityType: item }))
            }
            customLabelStyle={{
              fontWeight: '400',
              color: 'white',
              width: '100%'
            }}
          />
        </div>
      </div>

      {formData.PersonallyApprove && (
        <div style={{ marginBottom: '20px' }} className='Visibility-center'>
          <Text style={styles.labelPhoto}>Artists Sign-Up Visibility</Text>
          {[
            'Always Visible To The Artists',
            'A Week In Advance',
            'Select A Day To Open Artist Sign-Ups'
          ].map((label, index) => (
            <CheckboxContainer key={index}>
              <Checkbox
                onClick={() =>
                  setFormData(prev => ({ ...prev, AlwaysVisible: index + 1 }))
                }
              >
                <div
                  className={
                    formData.AlwaysVisible === index + 1
                      ? 'checkbox_F'
                      : 'checkbox_d'
                  }
                ></div>
              </Checkbox>
              <Text style={styles.labelPhoto}>{label}</Text>
            </CheckboxContainer>
          ))}
        </div>
      )}

      {formData.AlwaysVisible === 3 && (
        <div
          style={styles.EventDate}
          className={
            formData.PersonallyApprove ? 'display-block' : 'display-none'
          }
        >
          <div
            className={`Category_name ${
              errors.CustomDate ? 'invalid' : 'valid'
            }`}
            style={{
              marginBottom: '20px',
              width: '100%',
              position: 'relative'
            }}
          >
            <DatePicker
              selected={formData.CustomDate}
              onChange={date =>
                setFormData(prev => ({ ...prev, CustomDate: date }))
              }
              dateFormat='yyyy-MM-dd'
              className='p-2 border rounded w-full'
              onKeyDown={e => e.preventDefault()}
              customInput={
                <div style={styles.startDate}>
                  <img
                    src={Icons.Ic_newdate}
                    style={{ height: '20px' }}
                    alt='calendar icon'
                  />
                  <div className='fontSize16'>
                    {formData.CustomDate ? (
                      format(new Date(formData.CustomDate), 'MM/dd/yyyy')
                    ) : (
                      <div style={styles.customText_ad}>Date</div>
                    )}
                  </div>
                </div>
              }
            />
          </div>

          <div
            className={`Category_name ${
              errors.CustomTime ? 'invalid' : 'valid'
            }`}
            style={{
              marginBottom: '20px',
              width: '100%',
              position: 'relative',
              zIndex: '99'
            }}
          >
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              style={{ zIndex: 99, position: 'relative' }}
            >
              <MobileTimePicker
                style={{ zIndex: 99, position: 'relative' }}
                value={formData.CustomTime}
                onChange={newValue =>
                  setFormData(prev => ({ ...prev, CustomTime: newValue }))
                }
                open={openTimePicker}
                onClose={() => setOpenTimePicker(false)}
                components={{ OpenPickerIcon: Icons.ic_door }}
              />
              <div
                style={styles.startDate}
                onClick={() => setOpenTimePicker(true)}
                className='time-picker'
              >
                <img
                  src={Icons.Ic_newTime}
                  style={{ height: '20px' }}
                  alt='open time picker'
                />
                <div style={{ fontSize: '12px' }}>
                  {formData.CustomTime ? (
                    dayjs(formData.CustomTime).format('hh:mm A')
                  ) : (
                    <div style={styles.customText_ad}>Time</div>
                  )}
                </div>
              </div>
            </LocalizationProvider>
          </div>
        </div>
      )}

      {formData.ArtRunner !== 'Tour' && formData.PersonallyApprove && (
        <div style={{ marginBottom: '20px' }}>
          <label
            className='checkbox-container'
            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
          >
            <input
              type='checkbox'
              checked={formData.Settings}
              onChange={() =>
                setFormData(prev => ({ ...prev, Settings: !prev.Settings }))
              }
            />
            <span className='checkmark'></span>
            <Text style={{ color: 'white', marginLeft: '8px' }}>
              Save These Settings For Future Events
            </Text>
          </label>
        </div>
      )}
    </div>
  )
}

export default EventVisibility
